/** 区号国家/地区名称 - 简体中文 */
export default {
  areaCodes: {
  "1": "中国",
  "2": "中国香港",
  "3": "中国台湾",
  "4": "美国",
  "7": "中国澳门",
  "8": "安道尔共和国",
  "9": "阿拉伯联合酋长国",
  "10": "阿富汗",
  "11": "安提瓜和巴布达",
  "12": "安圭拉岛",
  "13": "阿尔巴尼亚",
  "14": "亚美尼亚",
  "15": "阿森松",
  "16": "安哥拉",
  "17": "阿根廷",
  "18": "奥地利",
  "19": "澳大利亚",
  "20": "阿塞拜疆",
  "21": "巴巴多斯",
  "22": "孟加拉国",
  "23": "比利时",
  "24": "布基纳法索",
  "25": "保加利亚",
  "26": "巴林",
  "27": "布隆迪",
  "28": "贝宁",
  "29": "巴勒斯坦",
  "30": "百慕大群岛",
  "31": "文莱",
  "32": "玻利维亚",
  "33": "巴西",
  "34": "巴哈马",
  "35": "博茨瓦纳",
  "36": "白俄罗斯",
  "37": "伯利兹",
  "38": "加拿大",
  "39": "开曼群岛",
  "40": "中非共和国",
  "41": "刚果",
  "42": "瑞士",
  "43": "库克群岛",
  "44": "智利",
  "45": "喀麦隆",
  "46": "哥伦比亚",
  "47": "哥斯达黎加",
  "48": "古巴",
  "49": "塞浦路斯",
  "50": "捷克",
  "51": "德国",
  "52": "吉布提",
  "53": "丹麦",
  "54": "多米尼加共和国",
  "55": "阿尔及利亚",
  "56": "厄瓜多尔",
  "57": "爱沙尼亚",
  "58": "埃及",
  "59": "西班牙",
  "60": "埃塞俄比亚",
  "61": "芬兰",
  "62": "斐济",
  "63": "法国",
  "64": "加蓬",
  "65": "英国",
  "66": "格林纳达",
  "67": "格鲁吉亚",
  "68": "法属圭亚那",
  "69": "加纳",
  "70": "直布罗陀",
  "71": "冈比亚",
  "72": "几内亚",
  "73": "希腊",
  "74": "危地马拉",
  "75": "关岛",
  "76": "圭亚那",
  "77": "洪都拉斯",
  "78": "海地",
  "79": "匈牙利",
  "80": "印度尼西亚",
  "81": "爱尔兰",
  "82": "以色列",
  "83": "印度",
  "84": "伊拉克",
  "85": "伊朗",
  "86": "冰岛",
  "87": "意大利",
  "88": "科特迪瓦",
  "89": "牙买加",
  "90": "约旦",
  "91": "日本",
  "92": "肯尼亚",
  "93": "吉尔吉斯坦",
  "94": "柬埔寨",
  "95": "朝鲜",
  "96": "韩国",
  "97": "科特迪瓦共和国",
  "98": "科威特",
  "99": "哈萨克斯坦",
  "100": "老挝",
  "101": "黎巴嫩",
  "102": "圣卢西亚",
  "103": "列支敦士登",
  "104": "斯里兰卡",
  "105": "利比里亚",
  "106": "莱索托",
  "107": "立陶宛",
  "108": "卢森堡",
  "109": "拉脱维亚",
  "110": "利比亚",
  "111": "摩洛哥",
  "112": "摩纳哥",
  "113": "摩尔多瓦",
  "114": "马达加斯加",
  "115": "马里",
  "116": "缅甸",
  "117": "蒙古",
  "118": "蒙特塞拉特岛",
  "119": "马耳他",
  "120": "马里亚那群岛",
  "121": "马提尼克",
  "122": "毛里求斯",
  "123": "马尔代夫",
  "124": "马拉维",
  "125": "墨西哥",
  "126": "马来西亚",
  "127": "莫桑比克",
  "128": "纳米比亚",
  "129": "尼日尔",
  "130": "尼日利亚",
  "131": "尼加拉瓜",
  "132": "荷兰",
  "133": "挪威",
  "134": "尼泊尔",
  "135": "荷属安的列斯",
  "136": "瑙鲁",
  "137": "新西兰",
  "138": "阿曼",
  "139": "巴拿马",
  "140": "秘鲁",
  "141": "法属玻利尼西亚",
  "142": "巴布亚新几内亚",
  "143": "菲律宾",
  "144": "巴基斯坦",
  "145": "波兰",
  "146": "波多黎各",
  "147": "葡萄牙",
  "148": "巴拉圭",
  "149": "卡塔尔",
  "150": "留尼旺",
  "151": "罗马尼亚",
  "152": "俄罗斯",
  "153": "沙特阿拉伯",
  "154": "所罗门群岛",
  "155": "塞舌尔",
  "156": "苏丹",
  "157": "瑞典",
  "158": "新加坡",
  "159": "斯洛文尼亚",
  "160": "斯洛伐克",
  "161": "塞拉利昂",
  "162": "圣马力诺",
  "163": "东萨摩亚(美)",
  "164": "西萨摩亚",
  "165": "塞内加尔",
  "166": "索马里",
  "167": "苏里南",
  "168": "圣多美和普林西比",
  "169": "萨尔瓦多",
  "170": "叙利亚",
  "171": "斯威士兰",
  "172": "乍得",
  "173": "多哥",
  "174": "泰国",
  "175": "塔吉克斯坦",
  "176": "土库曼斯坦",
  "177": "突尼斯",
  "178": "汤加",
  "179": "土耳其",
  "180": "特立尼达和多巴哥",
  "182": "坦桑尼亚",
  "183": "乌克兰",
  "184": "乌干达",
  "186": "乌拉圭",
  "187": "乌兹别克斯坦",
  "188": "圣文森特岛",
  "189": "委内瑞拉",
  "190": "越南",
  "191": "也门",
  "192": "南斯拉夫",
  "193": "南非",
  "194": "赞比亚",
  "195": "扎伊尔",
  "196": "津巴布韦"
}
};
